"use client";
import { HistoryEduOutlined as PublisherIcon } from "@mui/icons-material";

import { useStore, observer } from "../../../../service/mobx";
import SearchFilterChip from ".";
import { menuOptionsPublisher } from "../../../../component/Menu/menus/Search/Publisher";
import SearchMenu from "../../../../component/Menu/menus/Search";

export default observer(function FilterPublisher() {
  const { search } = useStore();
  const disabled =
    search.filterType === undefined ||
    search.filterType !== "papers" ||
    search.filterStars !== undefined;
  const param = "publisher";

  return (
    <SearchFilterChip
      param={param}
      disabled={disabled}
      StartIcon={PublisherIcon}
      options={menuOptionsPublisher}
      Menu={{
        sx: { menuList: { pt: 0 } },
        Component: () => (
          <SearchMenu
            param={param}
            filter="publisher"
            items={Object.entries(menuOptionsPublisher)}
          />
        )
      }}
    />
  );
});
